import { API } from "aws-amplify";
// ability to save a file we download through an API
import FileSaver from "file-saver";
// ensure a filename does not have invalid characters
import sanitize from "sanitize-filename";

// Configure the base URL for the fataskman service.
// This value comes from Amazon API Gateway, which links this URL to
// the actual service running in a Docker container.
function getTaskmanUrl() {
  var taskmanUrl = process.env.REACT_APP_TASKMAN_URL;
  if (!taskmanUrl) {
    // taskmanUrl = "http://localhost:3030";
    taskmanUrl = "https://h3vyawlm8a.execute-api.us-east-1.amazonaws.com/official-stage"; // default value
  }
  return taskmanUrl;
}

//***************************************************************************
// siteDoAction - send an action command to a site
// returns a Promise with the response from the REST API
//***************************************************************************
function siteDoAction(site, action) {
  console.log(`siteDoAction() ${action}, ${site}`);
  let apiName = "fataskman";

  return new Promise((resolve, reject) => {
    API.post(apiName, "/sites/" + site, { body: { action: action } })
      .then((response) => {
        console.log(apiName + " REST RESPONSE: " + JSON.stringify(response));
        if (response.result === "success") {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((error) => {
        console.log(apiName + " REST ERROR: ", error.response);
        reject(error.response);
      });
  });
}

/**
 * Download and save a file, getting the file contents from the
 * Task Manager API.
 * @param {string} apiPath Task Manager API path that responds with file contents
 * @param {string} filename The file name to save on the local machine
 */
function downloadFile(apiPath, filename) {
  const config = {
    responseType: "blob",
    response: true,
  };

  // Remove spaces and illegal characters from the file name
  filename = filename.replace(/ /g, "_");
  filename = sanitize(filename);

  API.get("fataskman", apiPath, config)
    .then((response) => {
      FileSaver.saveAs(response.data, filename);
    })
    .catch((err) => {
      console.error(`downloadFile() for ${filename}: `, err);
    });
}

export { getTaskmanUrl, siteDoAction, downloadFile };
